import { isPolygonClosed as d } from "@project-rouge/rg-core";
import { getByIndex as n } from "../../utils/array/index.js";
import { isPolygonClockwise as a } from "../is-polygon-clockwise/index.js";
import { V3toVector3 as r } from "../index9.js";
function b(t) {
  const o = a(t) ? t.slice() : t.slice().reverse();
  d(o) && o.pop();
  let s = 0, i = 0;
  for (let e = 0; e < o.length; e++) {
    const f = r(n(o, e - 1)), l = r(n(o, e)), p = r(n(o, e + 1)), c = l.clone().sub(f).normalize(), m = p.clone().sub(l).normalize(), u = c.cross(m);
    c.dot(m) > 0.99 || (u.y > 0 ? s++ : i++);
  }
  return { internal: s, external: i };
}
export {
  b as getPolygonCornerCount
};
//# sourceMappingURL=index15.js.map
